import Util from '../../Common/Util';
import Store from '../../Common/Store';

/*
 * 전자작업확인서 (/m/diary/done — mobile/pages/done.blade, 레이아웃 없는 독립 문서).
 * blade #page-data 를 생성자에서(initialize 전) 공유 전역으로 세운다 — ORDER 는 이 모듈과
 * F/Baljoo 모달(서명·가격·작업일시)이 맨이름으로 읽는다(옛 blade 인라인 let ORDER).
 * ⚠ 모듈 최상위에 두지 않는다 — m.js 가 Pages/Mobile/** 를 head 에서 즉시 평가해 모든 모바일 화면에서 돈다.
 */
function setupGlobals() {
    const D = JSON.parse(document.getElementById('page-data')?.textContent || '{}');
    window.ORDER = D.order || {};
    ORDER.$r = { sign_data: ORDER['sign_url'] };
    Object.assign(G5, {
        width: D.w, height: D.h,       // 서명 캔버스 해상도
        intro_view_cnt: 0,             // 인트로 본 횟수
        is_worker: D.isWorker,         // 수주자인가 — 금액변경 전 협의확인 여부
    });
    window.callbackAddress = callbackAddress;
}

/**
 * 주소선택후에 콜백함수 — 지도 검색 창(applyzip_first)이 부르는 창 사이 약속이라 window 에 둔다(setupGlobals).
 * @param arr ( lat : 위도 ( 37.56 ), long : 경도 ( 126.97 ), addr : 주소, place : 장소 이름 )
 */
function callbackAddress(arr) {
    if (arr['lat'].length < 5 || arr['long'].length < 5) {
        $j.Common.Util.swalert("위 경도값을 받지 못했습니다");
        return;
    }
    if (arr['addr'].length < 5) {
        $j.Common.Util.swalert("주소를 선택해 주세요");
        return;
    }
    if (arr['addr'] == "주소가없는 영역입니다. 맵을 움직여주세요") {
        $j.Common.Util.swalert("주소값이 없습니다. 지도를 조금 움직여서 주소값이 있는곳으로 이동해 주세요");
        return;
    }

    $('#paper_wc_addr').val(arr['place']);
    $j.p.update_change_mode('A');
    ORDER['site_address'] = arr['addr'];
    ORDER['confirm_addr'] = arr['place'];
    $j.p.print('addr');
}

export default class Done {
    constructor() {
        setupGlobals();
        this.change_mode = '';// 수정항목 H(작업일시),A(현장주소),P(소요시간/가격),S(싸인), D(작업완료)
        this.nego_agree = false;// 수주자가 금액변경 전 협의동의를 체크했는가 (저장요청까지 실어 처리이력에 남긴다)
    }

    /**
     * 화면 초기화, 이벤트핸들러 등록
     */
    initialize = function() {
        this.bindChrome();
        this.print('workdaytime');
        this.print('addr');
        this.print('howlong');
        this.print('price');
        this.print('sign');

        $('#paper_worker_name').text(Util.nvl(ORDER['driver_name']));// 기사명
        $('#paper_bonsa_col').text(Util.nvl(ORDER['bonsa_col']));// 본사별 부가정보(수임번호 등)
        $('#paper_car_name').text(ORDER['car_type'] + ' ' + ORDER['car_name'] + ' ' + ORDER['Car_plate_show']);// 장비명
        $('#paper_car_worktype').val(ORDER['work_content']);// 작업내용
        this.bindWorktypeInput();// 작업내용 글자수·줄수 제한
        $('#paper_wc_addr').val(ORDER['confirm_addr']);// 현장상세주소
        $('#paper_wc_name').val(ORDER['confirm_co_name']);// 업체명
        $('#paper_wc_phone').val(ORDER['confirm_phone']);// 연락처

        $j.Common.Form.registerPhoneHandler('paper_wc_phone');// 입력값 필터링

        $(document).on('click', function (e) {
            const $target = $(e.target);
            const $clickUnable = $target.closest('.click_unable');

            // click_unable인 경우에만 클릭 막기
            if ($clickUnable.length) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }

            // sign-map 관련 클릭 처리
            if ($target.attr('id') === 'sign-map' || $target.closest('#sign-map').length) {
                e.preventDefault();
                e.stopPropagation();
                $j.F.KakaoMap.open(ORDER['site_latlng'], '1');
                return false;
            }
        });

        // $('#sign-map').on('click', function () {
        //
        //     $j.F.KakaoMap.open(ORDER['site_latlng'], '1');
        // });

        // 작업확인서 2차 이상일 때 인풋 박스 클래스 변경
        if (ORDER.odr > 1) {
            $('.disable-if-odr').each(function () {
                $(this).removeClass('click_able').addClass('click_unable');
                $(this).off('click');

                if ($(this).is('input')) {
                    $(this).prop('readonly', true);
                }
            });
            $('#modify-count').text(`(${ORDER.odr}차)`);
            $('#first_orderConfirm').hide();
            $('#second_orderConfirm').css('display', 'flex');   // .flex_space_between — show() 는 block 으로 연다

            // 서명 있을 시 경고 변수
            let warnedOnce = false;
            let currentOdr = ORDER.odr; // odr 값을 미리 저장

            $('.edit_warning').each(function () {
                const $input = $(this);

                // focus 이벤트 핸들러 추가
                $input.on('focus', function(e) {
                    // overlay가 보이거나 sign_data가 있으면 포커스 제거
                    if ($('.wait_overlay').is(':visible') || ORDER.$r['sign_data']) {
                        e.preventDefault();
                        $input.blur();
                        return false;
                    }
                });

                // click 이벤트 핸들러
                $input.on('click', function (e) {
                    // overlay가 보이면 무조건 클릭 막기 (a태그 포함)
                    if ($('.wait_overlay').is(':visible')) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
                        $input.blur(); // 포커스 제거
                        Util.swalert([`<h2>수정불가(원격서명 대기중)</h2></br>\n<p>원격서명 대기중이라 수정이 불가능합니다. \n요청 취소 후 수정해 주시기 바랍니다.</p>`], null, ['확인']);
                        return false;
                    }

                    // click_unable 클래스를 가진 요소는 클릭 방지
                    if ($(e.target).hasClass('click_unable') || 
                        $(e.target).closest('.click_unable').length || 
                        $(e.target).find('.click_unable').length) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }

                    // true면 모든 클릭 방지
                    if (warnedOnce) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }

                    // sign_data가 있으면 모든 클릭 방지하고 경고창 표시
                    if (ORDER.$r['sign_data']) {
                        e.preventDefault();
                        e.stopPropagation();
                        handleEditWarning();
                        return false;
                    }

                    // sign_data가 없을 때만 a 태그 클릭 허용
                    if (!$(e.target).is('a') && !$(e.target).closest('a').length) {
                        e.preventDefault();
                    }
                });

                // 서명 체크 후 경고창 표시
                function handleEditWarning() {
                    // 실시간 체크로 수정
                    let editWarning = ORDER.$r['sign_data'];

                    // sign_data가 있을 때 경고창(문구2)
                    if (editWarning) {
                        if (warnedOnce) return;
                        let sendData = {
                            'odr' : ORDER.odr
                        }
                        Util.swalert([
                            `<h2>수정 및 2차 발행 시 재서명 필수</h2></br>
                        <p>수정 및 2차 발행 하시는 경우 기존 서명은 유효하지 않아 
                        다시 서명을 받으셔야 합니다.</p></br>
                        <p>그래도 진행하시겠습니까?</p>`
                        ], () => {
                            $.ajax({
                                type:"delete",
                                url:`/m/ajax/sign/order/${ORDER.num}` ,
                                data: sendData,
                                success:function(data){
                                    warnedOnce = true;
                                    location.reload();
                                }
                            });
                        }, ['확인', '취소']);
                        return;
                    }

                    // sign_data가 없으면 바로 입력 가능
                    return;
                }

                $input.blur(); // 포커스 초기화
            });

        } else {
            $('.disable-if-odr').each(function () {
                $(this).removeClass('click_unable').addClass('click_able');
            });
            $('#first_orderConfirm').css('display', 'flex');
            $('#second_orderConfirm').hide();
        }
    }
    /**
     * 모달을 띄운다.
     * @param id <div> id값
     * @param param
     */

    /**
     * 모달에서 선택한 값을 해당컬럼에 출력한다.
     * @param slideName 슬라이드명
     */
    print = (id)=>{
        let html = '';
        switch(id){
            case 'workdaytime':
                let dj = dayjs(ORDER.work_time);
                let Y=dj.format('YYYY');
                let m=dj.format('MM');
                let d=dj.format('DD');
                let H=dj.format('HH');
                let i=dj.format('mm');
                html = `<span >${Y}<span class="fw_regular fz_13"> 년</span> ${m}<span class="fw_regular fz_13"> 월</span> ${d}<span class="fw_regular fz_13"> 일</span>
${H}<span class="fw_regular fz_13">시</span> ${i}<span class="fw_regular fz_13">분</span>`;

                $('#paper_worktime').html(html);
                break;
            case 'addr':
                $('#contract_address').text(Util.nvl(ORDER.site_address));
                break;
            case 'price':
                // 회차는 시간유형·추가시간과 무관하게 '회차' 로 표기한다.
                // (금액변경 모달이 is_return_job 만 세우고 car_workdaytype/car_workhour 는 그대로 두므로
                //  getWorkHourStr 로는 '1일' 처럼 이전 값이 그려진다. 서버 OrderConfirmationService::get 과 같은 규칙)
                let isReturn = Util.int(ORDER['is_return_job']) === 1 && Util.int(ORDER['order_status']) !== 99;
                let hour_html = isReturn ? '회차' : $j.F.Car.getWorkHourStr(ORDER);
                let normal = hour_html;
                let additional = '';

                let idx = hour_html.indexOf(' (추가');
                if (idx !== -1) {
                    normal = hour_html.slice(0, idx).trim();       // "야간 1시간"
                    additional = hour_html.slice(idx).trim();      // "(추가 1시간)"
                }

                $('#paper_howlong').html(normal).data('addr', hour_html);
                $('#car_workaddhour').html(additional);
                $('#paper_car_price').html(Util.formatNumber(ORDER['car_price']));
                break;
            case 'sign':
                if( !ORDER.$r['sign_data'] ) return;
                $('#sign_thumb').attr('src', ORDER.$r['sign_data']).show();
                $('#sign_guide_text').hide();
                break;

        }

    }


    // 작업일시 모달 오픈
    /**
     * 화면 손잡이 — 옛 href="javascript:$j.p.…"·onclick·onfocus 를 여기서 잇는다.
     * [data-done] 는 문서 위임이라 아래 문서 클릭 처리(.click_unable 차단)보다 먼저 돈다 → 잠긴 칸은 여기서도 거른다.
     */
    bindChrome = function () {
        $(document).on('click', '[data-done]', (e) => {
            e.preventDefault();
            if ($(e.target).closest('.click_unable').length) return;
            const $el = $(e.currentTarget);
            const act = $el.data('done');
            if (act === 'apply') this.apply(Number($el.data('type')));
            else if (act === 'cancelRemoteSign') $j.F.Baljoo.ModalSign.cancel(ORDER['num'], ORDER['odr']);   // 원격서명 요청취소
            else this[act]();
        });

        // 입력 중엔 안내문(placeholder)을 지운다
        $('[data-ph-toggle]').each(function () { $(this).data('ph', this.placeholder); })
            .on('focus', function () { this.placeholder = ''; })
            .on('blur', function () { this.placeholder = $(this).data('ph'); });

        // 애니메이션 동작시에 닫기(X) 버튼 동작안하게 (jquery-modal #ex3)
        $('#ex3').on($.modal.OPEN, function () {
            $('#ex3').parent('.blocker').css('pointer-events', 'none');
            $('.align_wrap').css('pointer-events', 'none');
        });
        $('#ex3').on($.modal.CLOSE, function () {
            $('#ex3').parent('.blocker').css('pointer-events', 'auto');
            $('.align_wrap').css('pointer-events', 'auto');
        });
    }

    modalWorkTime = function (){
        const self = this;
        $j.Ui.BS.open({
            target: '$j.F.Baljoo.ModalWorkDayTime',
            fixedHeight: true,
            data: {
                work_time: ORDER['work_time'],
                onApply: (data) => {
                    $j.Ui.BS.applySnapshot(ORDER, data);
                    self.print('workdaytime');
                    self.update_change_mode('H');
                },
            },
        });
    }
    // 연락처 모달 오픈
    modalPhone = function (){
        const self = this;
        self.apply(3);

        setTimeout(function (){
            $j.Ui.BS.open({
                target: '$j.F.ModalPhone',
                data: {
                    $p: { from: '작업확인서', why: '연락처' },
                    onApply: ($r) => {
                        if (!ORDER.$r) ORDER.$r = {};
                        Object.assign(ORDER.$r, $r);
                        self.callback_apply_phone($r['hp']);
                    },
                },
            });
        }, 500);
    }
    // 서명 모달 오픈
    modalSign = function () {
        const self = this;
        $j.Ui.BS.open({
            target: '$j.F.Baljoo.ModalSign',
            fixedHeight: true,
            data: {
                $p: { w: G5['width'], h: G5['height'] },
                onApply: ($r) => {
                    if (!ORDER.$r) ORDER.$r = {};
                    Object.assign(ORDER.$r, $r);
                    self.print('sign');
                    self.update_change_mode('S');
                },
            },
        });
    }
    /**
     * 수주자가 금액을 바꾸기 전에 받는 협의 확인 — 일지(Diary/Main.js)와 같은 창이다.
     *
     * 금액은 발주자와 수주자 사이의 합의값인데 이 화면에서는 수주자가 혼자 고칠 수 있다.
     * 협의 없이 올린 금액이 확인서까지 가면 분쟁이 CS 로 온다 — 그래서 바꾸기 전에
     * '협의했다'를 손으로 받고, 그 사실을 저장요청에 실어 처리이력에 남긴다.
     * @return {Promise<boolean>} 동의하면 true
     */
    confirmNego = function (){
        // 문안·슬롯은 일지(Diary/Main.js confirmPriceChangeBySoo)와 **글자 하나까지 같다.**
        // 한쪽만 고치면 같은 창이 화면마다 다른 말을 한다 — 고칠 때 둘을 함께 고친다.
        return $j.Ui.Dialog.open({
            tone:    'danger',
            title:   '발주자와 협의 후 변경하세요',
            agree:   {
                noteHtml: '미협의로 생긴 분쟁·손해는 <b>본인</b> 책임입니다',
                label:    '협의 완료, 위 내용 동의',
            },
            hint:    '변경 내용은 발주자에게 통지됩니다',
            confirm: '변경',
            cancel:  '취소',
        });
    }
    // 가격수정 모달을 오픈한다.
    modalPrice = async function (){
        if( this.is_intro()) {
            this.modalIntro();
            return;
        }
        // 발주자에게는 묻지 않는다 — 자기 오더의 금액이라 협의의 주체가 다르다.
        if( Util.int(G5['is_worker']) === 1 ){
            if( !(await this.confirmNego()) ) return;
            this.nego_agree = true;
        }
        const self = this;
        $j.Ui.BS.open({
            target: '$j.F.Baljoo.ModalPrice',
            fixedHeight: true,
            data: Object.assign({}, ORDER, {
                // 잃는 쪽은 늘 발주자다 — 수주자가 고치는 자리면 저단가 확인창이 그렇게 말한다
                sky_role: Util.int(G5['is_worker']) === 1 ? 'soo' : 'bal',
                onApply: (data) => {
                    $j.Ui.BS.applySnapshot(ORDER, data);
                    self.print('price');
                    self.update_change_mode('P');
                },
            }),
        });
    }
    // 인트로를 보여준다.
    modalIntro = function (){
        G5['intro_view_cnt']++;
        $j.F.Baljoo.ModalChangePriceIntro.open();
    }

    /**
     * 저장 또는 작업종료 버튼을 눌렀을 때 title이나 동작
     * @param type 1(저장후닫기), 2(작업종료), 3(외부서명시)
     */
    apply = function (type) {
        const self = this;
        let title = '';
        // let urlType = 1;
        //
        // // 작업확인서 2차 이상이라면 urlType 2
        // if (ORDER.odr > 1) {
        //     urlType = 2;
        // }
        if (type === 1) {
            title = "현재까지 작성된 내용을 저장하시겠습니까?";
        } else if (type === 3) {
            // type 3일 땐 confirm 없이 바로 실행
            self.doApply(type); // 직접 실행
            return;
        } else {
            if(ORDER.odr > 1) {
                if ($('.wait_overlay').is(':visible')) {
                    Util.swalert([`<h2>수정완료 불가(원격서명 대기중)</h2></br><p>서명을 받은 후 수정완료 하시거나 
                    요청 취소 후 다른 담당자에게 원격서명 요청 바랍니다.</p>`], null, ['확인']);
                    return;
                }
                // if(!ORDER.$r['sign_data']){
                //     swalert([`<h2>수정완료 불가(서명 미입력)</h2></br><p>서명이 존재하지 않아 수정완료가 불가능합니다.
                //     서명을 입력하시기 바랍니다.</p>`],null,['확인']);
                //     return;
                // }
                title = "최종으로 수정완료 하시겠습니까?";
                this.update_change_mode('D');
            } else {
                if ($('.wait_overlay').is(':visible')) {
                    Util.swalert([`<h2>작업종료 불가(원격서명 대기중)</h2></br><p>서명을 받은 후 작업종료 처리 하시거나 
요청 취소 후 다른 담당자에게 원격서명 요청 바랍니다.</p>`], null, ['확인']);
                    return;
                }
//                 if(!ORDER.$r['sign_data']){
//                     swalert([`<h2>작업종료 불가(서명 미입력)</h2></br><p>서명이 존재하지 않아 작업종료가 불가능합니다.
// 서명을 입력하시기 바랍니다.</p>`],null,['확인']);
//                     return;
//                 }
                this.update_change_mode('D');
                this.confirmDone(type);
                return;
            }
        }
        Util.swalert([title, 'question'], () => {
            self.doApply(type);
        }, ['적용', '취소']);
    }

    /**
     * 작업종료 확인창 — 장비대금을 창에 띄워 보고 누르게 한다.
     * 이 화면에서는 수주자가 금액을 혼자 고칠 수 있어(modalPrice) 완료 전에 금액을 한 번 보게 하려는
     * 자리다. 경고 문장으로 "확인하라"고만 하면 기사가 뭔가 잘못 입력한 줄 알고 CS 에 묻는다 —
     * 금액을 보여주면 확인은 저절로 된다.
     */
    confirmDone = async function (type) {
        const ok = await $j.Ui.Dialog.open({
            title:   '작업완료 할까요?',
            rows:    [{ k: '장비대금', v: Util.formatNumber(ORDER.car_price) + '원' }],
            hint:    '금액이 다르면 취소하고 작업확인서에서 고친 뒤 완료해 주세요.',
            confirm: '작업완료',
            cancel:  '취소',
        });
        if (ok) this.doApply(type);
    }

    /**
     * 저장 또는 작업종료
     * @param type 1(저장), 2(작업종료)
     */
    doApply = function (type = 1) {
        let self = this;
        let base64 = ORDER.$r['sign_data'];
        if (self.change_mode.indexOf('S') == -1) base64 = '';
        let adr = ''
        let sendData;
        adr = `/m/ajax/order/${ORDER.num}/done`;

        sendData = {
            'odr': ORDER.odr,
            'mode': self.change_mode,
            'change_price_total': ORDER.car_price,
            'change_price_total_bonsa': ORDER.car_price_bonsa,
            'is_return': ORDER.is_return_job,
            'jobgoobun': ORDER.car_workdaytype, // 작업구분
            'jobworkhr': ORDER.car_workhour, // 작업시간
            'addHourIntval': ORDER.add_hour, // 추가시간
            'addHourType': ORDER.add_hour_type, // 추가시간타입(1:주간,2:야간)
            'addHourIntprice': ORDER.add_hour_price, // 추가금액
            'nego_agree': self.nego_agree ? 1 : 0, // 수주자 협의동의 (mode 에 P 가 있을 때만 기록된다)

            'work_time': ORDER.work_time, // 작업일시
            'contract_address': ORDER.site_address, // 현장주소
            'sign': base64, // 싸인이미지

            'wc_addr': $('#paper_wc_addr').val(),// 현장 세부주소
            'wc_name': $('#paper_wc_name').val(),// 업체명
            'wc_phone': $('#paper_wc_phone').val(),// 연락처
            'car_worktype': $('#paper_car_worktype').val(), // 작업내용
            'bonsa_col': $('#paper_bonsa_col').val(), // 본사별 부가정보(수임번호 등)

            'zzz': 999,
            'paper_howlong': $('#paper_howlong').data('addr')
        };
        $.ajax({
            type: "POST",
            url: adr,
            data: sendData,
            dataType: 'json',
            success: function (data) {
                if (data.result) {
                    const finish = () => {
                        // 완료는 됐지만 안내문구가 있으면(관리자 대리로그인 등) 먼저 보여준다.
                        if (data.message) {
                            Util.swalert(data.message, () => { if (type !== 3) self.go_diary(); });
                            return;
                        }
                        if (type !== 3) self.go_diary();
                    };

                    // 작업완료/수정완료 → 저장된 내용으로 A4 문서(HTML)를 캡처해 확인서 이미지를 교체
                    if (type === 2) {
                        self.saveConfirmDoc().then(finish, finish);
                    } else {
                        finish();
                    }
                    // console.log(data);
                    // if (type === 2) {
                    //     console.log('herehehe')
                    //     // 두 번째 Ajax 실행
                    //     $.ajax({
                    //         type: "POST",
                    //         url: `/m/ajax/order/${ORDER.num}/alimtalk`,
                    //         data: {
                    //             odr: ORDER.odr,
                    //             img_id: data.img_id
                    //         },
                    //         success: function () {
                    //             self.go_diary();
                    //         }
                    //     });
                    // } else if (type !== 3) {
                    //     self.go_diary();
                    // }
                } else {
                    Util.swalert(data.message);
                }
            }
        });
    }

    /**
     * 저장된 오더 내용으로 A4 작업확인서(HTML)를 캡처해 확인서 이미지를 갱신한다.
     * 좌표 방식(Intervention Image)으로 만든 서버 생성본을 이 캡처본이 덮어쓴다.
     * 캡처가 실패해도 서버 생성본이 남아 있으므로 작업완료 자체는 그대로 진행한다.
     * @returns {Promise}
     */
    saveConfirmDoc = function () {
        if (!window.OrderConfirmCapture) return Promise.resolve();

        const odr = ORDER.odr || 1;
        $j.Common.Util.loadingOverlay(true);
        return OrderConfirmCapture.save({
            // 저장되는 정본은 항상 사진 없는 버전. 작업사진은 갤러리에서 공유·저장할 때만 합성한다.
            docUrl: `/m/order/${ORDER.num}/confirm-doc?odr=${odr}&mode=plain`,
            saveUrl: `/m/ajax/order/${ORDER.num}/confirm-image`,
            params: { odr: odr },
        }).catch((e) => {
            console.warn('작업확인서 캡처 실패 — 서버 생성본 유지', e);
        }).finally(() => {
            $j.Common.Util.loadingOverlay(false);
        });
    }

    // 수정항목 업데이트하기
    update_change_mode = function(v){
        if( this.change_mode.indexOf(v)==-1 ) this.change_mode+=v;
    }


    /**
     * 알림톡으로 전송하기
     * @param hp
     */
    callback_apply_phone = function (hp){
        let ordernum = ORDER['num'];
        let howlong = $j.F.Car.getWorkHourStr(ORDER);
        let ad = $j.F.Car.getAddHourStr(ORDER);
        if( ad ) howlong+=`추가 ${ad}`;
        let phone = ORDER.$r.hp;
        let name = ORDER.$r.hp_name;
        let odr = ORDER.odr;

        let msg;
        if (!name){
            msg =`<h2>${Util.escapeHtml(phone)}</h2></br><div>원격서명을 요청하시겠습니까?</div>`
        } else {
            msg = `<h2>${Util.escapeHtml(name)} ${Util.escapeHtml(phone)}</h2></br><div>원격서명을 요청하시겠습니까?</div>`
        }
        Util.swalert([msg],() =>{
            $.ajax({
                url: '/m/ajax/sign/order/request',
                type: 'post',
                data: {
                    'ordernum': ordernum,
                    'sign_phone': phone,
                    'odr' : odr
                },
                success: function (data) {
                    // setTimeout($('.wait_overlay').show(),50);
                    $('.wait_overlay').show();
                }
            });
        },['서명요청','취소']);


    }

    /**
     * 작업확인서 작업내용 — 남은 글자수 표시 + 줄수 제한.
     * 엔터로 2줄까지 쓸 수 있다(A4 서식의 작업내용 칸이 감당하는 줄수).
     * 같은 기준을 서버(OrderConfirmationService::clampWorkContent)도 적용한다.
     */
    bindWorktypeInput(){
        const MAX_LINES = 2;
        const $input = $('#paper_car_worktype');
        const $count = $('#paper_car_worktype_count');
        if( !$input.length ) return;

        const max = parseInt($input.attr('data-maxlen'), 10) || 0;
        const draw = () => {
            const len = $input.val().length;
            $count.text(`${len}/${max}`).css('color', len >= max ? '#e74c3c' : '#999');
        };

        // 이미 2줄이면 엔터를 더 받지 않는다
        $input.on('keydown', function (e) {
            if( e.key !== 'Enter' ) return;
            if( $(this).val().split('\n').length >= MAX_LINES ) e.preventDefault();
        });

        // 한도를 넘기면 잘라내고 알린다. maxlength 로 조용히 막으면 왜 안 써지는지 알 수 없다.
        $input.on('input', function () {
            const v = $(this).val();
            if( v.length > max ){
                $(this).val(v.substring(0, max));
                $j.Ui.Dialog.open({
                    tone:    'warn',
                    title:   `작업내용은 ${max}자까지 입력할 수 있습니다`,
                    confirm: '확인',
                });
            }
            draw();
        });
        draw();
    }

    // 일지로
    go_diary(){
        let url='/m/diary?showipicknum='+ORDER['num'];
        location.href=url;
    }

    /**
     * 인트로를 보여줄지여부
     * @returns {boolean}
     */
    is_intro(){
        let t = Store.cookie.get('price_intro');
        if( G5['intro_view_cnt']==0 && t!=1 ){
            return true;
        }
        return false;
    }


}
